import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";
import CoachChat from "./CoachChat";

export default function CoachDock() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return (
    <>
      <button className="coach-fab" onClick={() => setOpen(!open)} data-testid="coach-open-btn" aria-label="Ask your coach">
        <MessageCircle size={16} /> Ask your coach
      </button>
      {open && <div className="coach-dock" data-testid="coach-dock">
        <div className="coach-dock-head">
          <div><b>Ask your coach</b><div className="sub" style={{ margin: 0 }}>Same conversation as the Coach page</div></div>
          <div className="flex gap-2 items-center">
            <Link to="/coach" className="btn ghost sm" onClick={() => setOpen(false)} data-testid="coach-dock-full-link">Open full Coach page</Link>
            <button className="btn ghost sm" onClick={() => setOpen(false)} data-testid="coach-close-btn"><X size={14} /></button>
          </div>
        </div>
        <CoachChat height={380} />
      </div>}
    </>
  );
}
